import { useNavigate } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Box, Button, Paper, Typography } from '@mui/material';

export const MFASuccess = () => {
  const navigate = useNavigate();

  const handleReturnToLogin = () => {
    navigate('/auth/login', { replace: true });
  };
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '3.5rem',
        width: '28rem',
        height: '100%',
      }}
    >
      <Paper
        elevation={8}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: '1.5rem',
          //   paddingBlock: '3rem',
          gap: '16px',
          width: '100%',
          borderRadius: 0,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '16px',
            padding: 0,
          }}
        >
          <CheckCircleIcon sx={{ fontSize: '3rem' }} color='primary' />
          <Typography
            sx={{ fontWeight: '600', fontSize: '1.5rem', color: 'primary' }}
          >
            Success!
          </Typography>
        </Box>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Typography
            sx={{
              paddingY: '24px',
              fontSize: '16px',
              lineHeight: '24px',
              fontWeight: '400',
              textAlign: 'center',
            }}
          >
            You have successfully set up multi-factor authentication. Click the
            button below to finish signing in.
          </Typography>
        </Box>

        <Button
          variant='contained'
          color='secondary'
          sx={{ color: 'white', padding: '0.5rem', fontWeight: '500' }}
          onClick={handleReturnToLogin}
          fullWidth
        >
          FINISH
        </Button>
      </Paper>
    </Box>
  );
};
